// @flow
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './Seo.module.scss';

type Props = {};

const Seo = () => {
    // TODO: replace strings with <FormattedMessages />
    return (
        <div className={styles.seo}>
            <div className={styles.container}>
                <div className={styles.column}>
                    <div className={styles.wrapper}>
                        <div className={styles['column-title']}>
                            <FormattedMessage id="popular_searches" />
                        </div>
                        <ul>
                            <li>
                                <Link route to="/c/art/chinese/1/162/">
                                    Chinese Art
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/clocks/74/">
                                    Clocks
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/coins-medals-money/24/">
                                    Coins and Paper Money
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/jade/25797/">
                                    Jade
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={styles.column}>
                    <div className={styles.wrapper}>
                        <div className={styles['column-title']}>
                            <FormattedMessage id="artists_and_creators" />
                        </div>
                        <ul>
                            <li>
                                <Link route to="/c/finn-juhl/7645/">
                                    Finn Juhl
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/hans-wegner/9858/">
                                    Hans Wegner
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/keith-haring/14133/">
                                    Keith Haring
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/marc-chagall/15935/">
                                    Marc Chagall
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={styles.column}>
                    <div className={styles.wrapper}>
                        <div className={styles['column-title']}>
                            <FormattedMessage id="brands" />
                        </div>
                        <ul>
                            <li>
                                <Link route to="/c/chanel/4017/">
                                    Chanel
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/hermes/10420/">
                                    Hermès
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/louis-vuitton/15385/">
                                    Louis Vuitton
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/rolex/21252/">
                                    Rolex
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={styles.column}>
                    <div className={styles.wrapper}>
                        <div className={styles['column-title']}>
                            <FormattedMessage id="style_periods" />
                        </div>
                        <ul>
                            <li>
                                <Link route to="/c/art-deco/253/">
                                    Art Deco
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/byzantine/25695/">
                                    Byzantine
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/edwardian/274/">
                                    Edwardian
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/gothic/252/">
                                    Gothic
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={styles.column}>
                    <div className={styles.wrapper}>
                        <div className={styles['column-title']}>
                            <FormattedMessage id="origins" />
                        </div>
                        <ul>
                            <li>
                                <Link route to="/c/japanese/163/">
                                    Japanese
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/tibetan/168/">
                                    Tibetan
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/southeast-asian/169/">
                                    Southeast Asian
                                </Link>
                            </li>
                            <li>
                                <Link route to="/c/taiwanese/165/">
                                    Taiwanese
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(Seo);
